<template>
  <b-modal
    id="copy-code-modal"
    title="Copy code"
    hide-footer
    centered
  >
    <div class="d-flex align-items-center mb-2">
      <b-avatar
        rounded
        size="42"
        variant="light-info"
        class="mr-1"
      >
        <feather-icon
          icon="AlertCircleIcon"
          size="20"
        />
      </b-avatar>
      <div>
        <h4 class="mb-0">
          Copy code
        </h4>
        <span>Copy the code below to integrate with our service</span>
      </div>
    </div>

    <div class="mt-2">
      <b-form-input
        ref="tarea"
        v-model="code"
        variant="primary"
        placeholder="Code"
        class="mb-1"
      />
      <b-button
        v-clipboard:copy="code"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
        v-b-tooltip.hover.top="$t('widgets.copybutton')"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        block
      >
        <feather-icon icon="CopyIcon" /> {{ $t('form.copy') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import {
  BModal,
  BAvatar,
  BFormInput,
  VBTooltip,
  BButton,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'CopyCodeModal',
  components: {
    BModal,
    BAvatar,
    BFormInput,
    BButton,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  props: {
    partnerId: {
      type: String,
      required: true,
    },
  },
  computed: {
    code() {
      return `https://rtb-eu.phoenix-widget.com/api/v1/ortb/${this.partnerId}/`
    },
  },
  methods: {
    onCopy() {
      try {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Code copied',
            icon: 'BellIcon',
          },
        })
        this.$refs.tarea.focus()
        this.$refs.tarea.select()
      } catch (error) {
        this.$store.dispatch(
          'error-store/showNotify',
          {
            title: error.response?.statusText || 'Error',
            msg: error.message,
            variant: 'danger',
          },
          { root: true },
        )
      }
    },
    onError(error) {
      this.$store.dispatch(
        'error-store/showNotify',
        {
          title: error.response?.statusText || 'Error',
          msg: error.message || 'Failed to copy code!',
          variant: 'danger',
        },
        { root: true },
      )
    },
  },
}
</script>
